import React, { FC, useEffect } from 'react'
import Button from '../../../components/Atoms/Button/Button'
import useForm, { OnSubmitParams } from '../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsRight,
} from '../../../components/Organisms/Form/Form.styles'
import utils from '../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../translations/main'
import { FormProps } from '../../Pages/Onboarding/types'

const ExampleForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    toggleShowByName,
  } = useForm(props.fetchedData, config, submitForm)

  useEffect(() => {
    toggleShowByName('postCode', formData?.city?.value !== '')
  }, [formData?.city?.value])

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>{t('onboarding.forms.Example.title')}</FormTitle>
      </FormHeader>
      {utils.sectionBuilder(config, formData, handleInputChange)}
      <FormFooter>
        <FormFooterActionsRight>
          <Button type='submit' label='Submit' disabled={emptyValidation} />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default ExampleForm
